import { userStore } from 'partners-widget-core';
import { createInjectionState } from '@vueuse/shared';
import {
  computed,
  reactive,
  toRefs,
} from '@vue/composition-api';

import {
  ISO_CODE_RUSSIA,
  ISO_CODE_UKRAINE,
  ISO_CODE_GREAT_BRITAIN,
  MAIN_REGIONS,
} from '@/utils/constants/globalConst';

const [useLocationProvider, useLocationStore] = createInjectionState(() => {
  // TODO: выпилить дефолтные значения иначе не корректно определяется местоположение
  const state = reactive({
    cityName: userStore.store.location.cityName || MAIN_REGIONS.msk.name,
    cityLocation: userStore.store.location.cityLocation || MAIN_REGIONS.msk.code,
  });

  const isMoscow = computed(() => state.cityLocation === MAIN_REGIONS.msk.code);

  const isMoscowRegion = computed(() => MAIN_REGIONS.msk.regionFiasList.includes(state.locationRegionCode));

  const isSpb = computed(() => state.cityLocation === MAIN_REGIONS.spb.code);

  const isSpbRegion = computed(() => MAIN_REGIONS.spb.regionFiasList.includes(state.locationRegionCode));

  const isSpbOrMoscow = computed(() => isMoscow.value || isSpb.value);

  const isRussian = computed(() => state.countryCode === ISO_CODE_RUSSIA);

  const isUkraine = computed(() => state.countryCode === ISO_CODE_UKRAINE);

  const isGreatBritain = computed(() => state.countryCode === ISO_CODE_GREAT_BRITAIN);

  const isUaOrGb = computed(() => isUkraine.value || isGreatBritain.value);
  return {
    ...toRefs(state),
    isRussian,
    isUkraine,
    isGreatBritain,
    isUaOrGb,
    isMoscow,
    isMoscowRegion,
    isSpb,
    isSpbRegion,
    isSpbOrMoscow,
  };
});

const useLocationContext = () => {
  const locationStore = useLocationStore();

  if (!locationStore) {
    throw new Error('Пожалуйста, вызовите `useLocationProvider` для соответствующего родительского компонента.');
  }

  return locationStore;
};

export { useLocationProvider, useLocationContext };
